// removed by extract-text-webpack-plugin
module.exports = {"Buttons":"Switcher__Buttons___2XwMx","ButtonsСhessfilter":"Switcher__ButtonsСhessfilter___1ct3F","Button":"Switcher__Button___1D6GF","EnabledElement":"Switcher__EnabledElement___2F3hz","Round":"Switcher__Round___3jEqi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Switcher/Switcher.scss
// module id = 1466
// module chunks = 0